const enum AppStoreReadyStateEnum {
  pending = 'pending',
  loading = 'loading',
  loaded = 'loaded',
  error = 'error',
  idle = 'idle',
}

export default AppStoreReadyStateEnum;
